import request from '~/request/index.js'

/**
 * 获取部门列表
 *   GET /api/v1/admin/dept/list
 *   接口ID：234077395
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-234077395
 */
export const getDeptListApi= ()=> request.get('/api/v1/admin/dept/list')

/**
 * 新增部门
 *   POST /api/v1/admin/dept
 *   接口ID：234077397
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-234077397
 */
export const addDeptApi= (data)=> request.post('/api/v1/admin/dept',data)

/**
 * 修改部门
 *   PUT /api/v1/admin/dept
 *   接口ID：234077398
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-234077398
 */
export const modifyDeptApi= (data)=> request.put('/api/v1/admin/dept',data)

/**
 * 删除部门
 *   DELETE /api/v1/admin/dept/{deptId}
 *   接口ID：234077399
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-234077399
 */
export const deleteDeptApi= (deptId)=> request.delete(`/api/v1/admin/dept/${deptId}`)

/**
 * 获取部门下的所有用户信息
 *   GET /api/v1/admin/user/list/dept/{deptId}
 *   接口ID：234078809
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-234078809
 */
export const getUserListByDeptIdApi= (deptId)=> request.get(`/api/v1/admin/user/list/dept/${deptId}`)

/**
 * 新增用户
 *   POST /api/v1/admin/user
 *   接口ID：234078801
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-234078801
 */
export const addUserApi= (data)=> request.post('/api/v1/admin/user',data)

/**
 * 修改用户
 *   PUT /api/v1/admin/user
 *   接口ID：234078802
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-234078802
 */
export const modifyUserApi= (data)=> request.put('/api/v1/admin/user',data)
/**
 * 删除用户
 *   DELETE /api/v1/admin/user/{userIds}
 *   接口ID：234078803
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-234078803
 */
export const deleteUserApi= (userIds)=> request.delete(`/api/v1/admin/user/${userIds}`)
/**
 * 根据用户编号获取详细信息
  GET /api/v1/admin/user/
  接口ID：234078800
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-234078800
 */
export const getUserApi= (userId)=> request.get(`/api/v1/admin/user/${userId}`)
/**
 * 状态修改
 *   PUT /api/v1/admin/user/changeStatus
 *   接口ID：234078805
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-234078805
 */
export const changeStatusApi= (data)=> request.put('/api/v1/admin/user/changeStatus',data)

/**
 * 获取用户列表
 *   GET /api/v1/admin/user/list
 *   接口ID：234078799
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-234078799
 */
export const getDifferentUserListApi = (status) => request.get(`/api/v1/admin/user/list?status=${status}`);

/**
 * 获取角色信息列表
 *   GET /api/v1/admin/role/list
 *   接口ID：234097517
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-234097517
 */
export const getRoleListApi = () => request.get('/api/v1/admin/role/list');

/**
 * 新增角色
 *   POST /api/v1/admin/role
 *   接口ID：234097519
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-234097519
 */
export const addRoleApi = (data) => request.post('/api/v1/admin/role', data);
/**
 * 修改保存角色
 *   PUT /api/v1/admin/role
 *   接口ID：234097520
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-234097520
 */
export const modifyRoleApi = (data) => request.put('/api/v1/admin/role', data);
/**
 * 查询角色下面的用户
 *   GET /api/v1/admin/role/authUser/allocatedList
 *   接口ID：234097523
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-234097523
 */
export const getRoleAuthUserAllocatedListApi = (roleId) => request.get(`/api/v1/admin/role/authUser/allocatedList?roleId=${roleId}`);

/**
 * 删除角色
 *   DELETE /api/v1/admin/role/{roleIds}
 *   接口ID：234097521
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-234097521
 */
export const deleteRoleApi = (roleIds) => request.delete(`/api/v1/admin/role/${roleIds}`);

/**
 * 修改保存角色菜单权限
 *   PUT /api/v1/admin/role
 *   接口ID：234097520
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-234097520
 */
export const modifyMenuPermissionRoleApi = (data) => request.put('/api/v1/admin/role', data);


/**
 * 批量选择用户授权
 *   PUT /api/v1/admin/role/authUser/selectAll
 *   接口ID：234097527
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-234097527
 */
export const selectAllAuthUserApi = (roleId,userIds) => request.put(`/api/v1/admin/role/authUser/selectAll?roleId=${roleId}&userIds=${userIds}`);

/**
 * 获取用户列表
 *   GET /api/v1/admin/user/list
 *   接口ID：234078799
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-234078799
 */
export const getUserListApi = () => request.get('/api/v1/admin/user/list');

/**
 * 取消授权用户
 *   PUT /api/v1/admin/role/authUser/cancel
 *   接口ID：234097525
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-234097525
 */
export const cancelAuthUserApi = (data) => request.put(`/api/v1/admin/role/authUser/cancel`,data);

/**
 * 批量取消授权用户
 *   PUT /api/v1/admin/role/authUser/cancelAll
 *   接口ID：234097526
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-234097526
 */
export const cancelAllAuthUserApi = (roleId,userIds) => request.put(`/api/v1/admin/role/authUser/cancelAll?roleId=${roleId}&userIds=${userIds}`);

/**
 * 获取路由信息
 *   GET /api/v1/admin/menu/router
 *   接口ID：234110113
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-234110113
 */
export const getRouterApi = () => request.get('/api/v1/admin/menu/router');

/**
 * 获取所有菜单列表
 *   GET /api/v1/admin/menu/treeSelect
 *   接口ID：234110114
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-234110114
 */
export const getAllMenuListApi = ()=>request.get('/api/v1/admin/menu/treeSelect');
/**
 * 加载角色下的菜单列表树
 *   GET /api/v1/admin/menu/treeSelect/{roleId}/role
 *   接口ID：234110115
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-234110115
 */
export const getMenuListByRoleIdApi = (roleId)=>request.get(`/api/v1/admin/menu/treeSelect/${roleId}/role`);

/**
 * 获取企业微信授权链接
 *   GET /wecom-auth/auth-url
 *   用于获取企业微信授权的URL
 */
export const getWecomAuthUrlApi = () => request.get('/wecom-auth/auth-url');

/**
 * 企业微信授权回调
 *   POST /wecom-auth/callback
 *   用于处理企业微信授权回调，绑定企业
 */
export const wecomAuthCallbackApi = (code, state) => request.post(`/wecom-auth/callback?code=${code}&state=${state}`);


/**
 * 获取企业微信配置信息
 *   GET /wecom-auth/config
 *   用于获取企业微信授权状态和公司信息
 */
export const getWecomConfigApi = () => request.get('/wecom-auth/config');

/**
 * 获取第三方配置信息带有租户id和平台
 * GET /wecom-auth/config
 */
export const getThirdPartyConfigApi = (data) => request.get('/wecom-auth/config', { params: data });

/**
 * 
 * @returns 
 */
/**
 * 取消企业微信授权
 *   POST /wecom-auth/cancel
 *   用于取消企业微信授权
 */
export const cancelWecomAuthApi = () => request.put('/wecom-auth/cancel');

/**
 * 第三方配置
  POST /wecom-auth
  接口ID：354393607
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-354393607
 */
export const thirdPartyConfigApi = (data) => request.post('/wecom-auth', data);

/**
 * 飞同步组织架构
  POST /wecom-auth/lark/get-org-structure
  接口ID：356223346
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-356223346
 */
export const larkOrganizationalSyncApi = () => request.post('/wecom-auth/lark/get-org-structure');


/**
 * 钉钉同步组织架构
  POST /wecom-auth/dingtalk/get-org-structure
  接口ID：356223346
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-356223346
 */
export const dingTalkOrganizationalSyncApi = () => request.post('/wecom-auth/dingtalk/get-org-structure');


/**
取消某个第三方应用的授权
  DELETE /wecom-auth/cancel/{authType}
  接口ID：368577640
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-368577640
 */
export const cancelThirdPartyAuthApi = (authType) => request.delete(`/wecom-auth/cancel/${authType}`);